import React from 'react'
import "./ProductItem.css"
import {Star} from "phosphor-react"
import {removeFromCart} from "../redux/cartSlice"
import { useDispatch, useSelector } from 'react-redux'
import { nanoid } from '@reduxjs/toolkit'
import{setTotal} from "../redux/totalSlice"

function ProductItem({id, image, title, price, rating, hideButton}) { 
  const dispatch = useDispatch()
  const basket = useSelector(state=> state.cart.basket)

  React.useEffect(()=> {
    let total = 0;
    for(let i =0; i< basket.length; i++){
        total += basket[i].price
    }
    dispatch(setTotal(total))

  }, [basket])


  return (
    <div className='productItem'>
        <img src={image} className='productItem-image'/>

        <div  className='productItem-info'>
            <div  className='productItem-title'>
                {title}
            </div>

            <div className='productItem-price'><small>${price}</small></div>
                <div className='productItem-rating'>

                    {
                    Array(rating).fill().map((_,i) => (<Star key={nanoid} size={20} color="#f6ce04" weight="fill" />))}
                </div>
                {
                  !hideButton && <button className='productItem-remove-button' onClick={() => dispatch(removeFromCart(id))}> Remove from Basket</button>
                }
        </div>
        
    </div>
  )
}

export default ProductItem